import {
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
  fromInt2ii0rejb1w62w as fromInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import {
  awaitContent$default2k2a3zkrv0yyf as awaitContent$default,
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
} from './ByteReadChannel.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function transferFromDelegate($this) {
  updateConsumed($this);
  var appended = $this.o4o_1.x4j($this.n4o_1.k4m());
  $this.p4o_1 = add($this.p4o_1, appended);
}
function updateConsumed($this) {
  $this.q4o_1 = add($this.q4o_1, subtract($this.p4o_1, $this.o4o_1.q2()));
  $this.p4o_1 = $this.o4o_1.q2();
}
var CountedByteReadChannelClass;
function CountedByteReadChannel() {
  if (CountedByteReadChannelClass === VOID) {
    class $ {
      constructor(delegate) {
        this.n4o_1 = delegate;
        this.o4o_1 = new (Buffer())();
        this.p4o_1 = 0n;
        this.q4o_1 = 0n;
      }
      r4o() {
        updateConsumed(this);
        return this.q4o_1;
      }
      g4m() {
        return this.n4o_1.g4m();
      }
      b4n() {
        return this.o4o_1.s3y() && this.n4o_1.b4n();
      }
      k4m() {
        transferFromDelegate(this);
        return this.o4o_1;
      }
      *e4n(min, $completion) {
        if (this.k4m().q2() >= fromInt(min)) {
          return true;
        }
        if (yield* this.n4o_1.e4n(min, $completion)) {
          transferFromDelegate(this);
          return true;
        }
        return false;
      }
      o4n(cause) {
        this.n4o_1.o4n(cause);
        this.o4o_1.m6();
      }
    }
    protoOf($).k4n = awaitContent$default;
    initMetadataForClass($, 'CountedByteReadChannel', VOID, VOID, [ByteReadChannel()], [1]);
    CountedByteReadChannelClass = $;
  }
  return CountedByteReadChannelClass;
}
function counted(_this__u8e3s4) {
  return new (CountedByteReadChannel())(_this__u8e3s4);
}
//region block: exports
export {
  counted as counted3iniv3aql3f9n,
};
//endregion

//# sourceMappingURL=CountedByteReadChannel.mjs.map
